import React from 'react';
import { SvgProps } from './icon.props';

const ThumbUpSvg: React.FC<SvgProps> = ({ color, height, width }) => {
  return (
    <svg
      width={width || 64}
      height={height || 65}
      viewBox="0 0 64 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse
        cx="32"
        cy="32.695"
        rx="32"
        ry="31.8459"
        fill={color || '#F7F7F7'}
      />
      <g clipPath="url(#clip0_2690_42543)">
        <path
          d="M37.625 16.7721C37.2799 16.7721 37 17.0506 37 17.3941V20.2552C37 20.5987 37.2799 20.8772 37.625 20.8772C37.9701 20.8772 38.25 20.5987 38.25 20.2552V17.3941C38.25 17.0506 37.9701 16.7721 37.625 16.7721Z"
          fill={color || '#1F1F1F'}
        />
        <path
          d="M23.25 36.1782C22.905 36.1782 22.625 36.4569 22.625 36.8002C22.625 37.1436 22.905 37.4222 23.25 37.4222C23.595 37.4222 23.875 37.1436 23.875 36.8002C23.875 36.4569 23.595 36.1782 23.25 36.1782Z"
          fill={color || '#1F1F1F'}
        />
        <path
          d="M46.375 34.9343C46.375 33.5624 45.2535 32.4463 43.875 32.4463H39.2092C39.9316 30.605 40.2239 28.4378 40.1676 26.5085C40.1568 26.1404 40.1426 25.9275 40.1234 25.7934C40.0911 24.4495 38.9823 23.3652 37.625 23.3652C36.2465 23.3652 35.125 24.4813 35.125 25.8532V26.4752C35.125 30.409 30.0491 32.6193 26.2185 33.5671C25.9289 32.9081 25.2677 32.4463 24.5 32.4463H18.25C17.9049 32.4463 17.625 32.7248 17.625 33.0683V47.9961C17.625 48.3395 17.9049 48.618 18.25 48.618H24.5C25.2626 48.618 25.9199 48.1623 26.2126 47.5103C26.5297 47.5913 26.8242 47.6678 27.096 47.7385C29.2782 48.3057 30.4802 48.618 33.4037 48.618H40.125C41.5035 48.618 42.625 47.5019 42.625 46.1301C42.625 45.6186 42.4689 45.1427 42.2019 44.7469C43.1674 44.4108 43.875 43.4928 43.875 42.3981C43.875 41.8885 43.7227 41.4111 43.4565 41.0135C44.4177 40.6768 45.125 39.7609 45.125 38.6662C45.125 38.1547 44.9689 37.6788 44.7019 37.283C45.6674 36.947 46.375 36.0289 46.375 34.9343ZM25.125 46.7521C25.125 47.095 24.8446 47.3741 24.5 47.3741H18.875V33.6903H24.5C24.8446 33.6903 25.125 33.9693 25.125 34.3123V46.7521ZM43.875 36.1782C42.5344 36.1782 42.2149 36.1782 40.75 36.1782C40.4049 36.1782 40.125 36.4568 40.125 36.8002C40.125 37.1437 40.4049 37.4222 40.75 37.4222H42.625C43.3143 37.4222 43.875 37.9803 43.875 38.6662C43.875 39.3532 43.3154 39.9102 42.625 39.9102H39.5C39.1549 39.9102 38.875 40.1887 38.875 40.5322C38.875 40.8756 39.1549 41.1542 39.5 41.1542H41.375C42.0561 41.1542 42.625 41.6956 42.625 42.3981C42.625 43.0852 42.0654 43.6421 41.375 43.6421C40.0344 43.6421 39.7149 43.6421 38.25 43.6421C37.9049 43.6421 37.625 43.9206 37.625 44.2641C37.625 44.6076 37.9049 44.8861 38.25 44.8861H40.125C40.8143 44.8861 41.375 45.4441 41.375 46.1301C41.375 46.816 40.8143 47.3741 40.125 47.3741H33.4037C30.6408 47.3741 29.5617 47.0936 27.4119 46.5349C27.0969 46.453 26.7515 46.3633 26.375 46.2677V34.8114C30.898 33.7392 36.375 31.1221 36.375 26.4752V25.8532C36.375 25.1673 36.9357 24.6092 37.625 24.6092C38.313 24.6092 38.8737 25.1664 38.875 25.8513V25.8532C38.875 26.1235 39.214 29.441 37.8546 32.4463H35.75C35.4049 32.4463 35.125 32.7248 35.125 33.0683C35.125 33.4117 35.4049 33.6903 35.75 33.6903C36.1864 33.6903 43.1626 33.6903 43.875 33.6903C44.5643 33.6903 45.125 34.2483 45.125 34.9343C45.125 35.6213 44.5654 36.1782 43.875 36.1782Z"
          fill={color || '#1F1F1F'}
        />
        <path
          d="M23.25 38.6661C22.9049 38.6661 22.625 38.9447 22.625 39.2881V44.2641C22.625 44.6075 22.9049 44.886 23.25 44.886C23.5951 44.886 23.875 44.6075 23.875 44.2641V39.2881C23.875 38.9447 23.5951 38.6661 23.25 38.6661Z"
          fill={color || '#1F1F1F'}
        />
        <path
          d="M32.625 24.6091H30.125C29.7799 24.6091 29.5 24.8877 29.5 25.2311C29.5 25.5746 29.7799 25.8531 30.125 25.8531H32.625C32.9701 25.8531 33.25 25.5746 33.25 25.2311C33.25 24.8877 32.9701 24.6091 32.625 24.6091Z"
          fill={color || '#1F1F1F'}
        />
        <path
          d="M45.125 24.6091H42.625C42.2799 24.6091 42 24.8877 42 25.2311C42 25.5746 42.2799 25.8531 42.625 25.8531H45.125C45.4701 25.8531 45.75 25.5746 45.75 25.2311C45.75 24.8877 45.4701 24.6091 45.125 24.6091Z"
          fill={color || '#1F1F1F'}
        />
        <path
          d="M43.3701 19.5138C43.1259 19.271 42.7303 19.271 42.4861 19.5138L40.7187 21.2727C40.4746 21.5156 40.4746 21.9094 40.7187 22.1524C40.9629 22.3953 41.3584 22.3952 41.6026 22.1524L43.3701 20.3935C43.6141 20.1506 43.6141 19.7567 43.3701 19.5138Z"
          fill={color || '#1F1F1F'}
        />
        <path
          d="M34.5307 21.2727L32.7633 19.5138C32.5191 19.271 32.1235 19.271 31.8793 19.5138C31.6353 19.7567 31.6353 20.1505 31.8793 20.3935L33.6468 22.1524C33.891 22.3953 34.2866 22.3952 34.5307 22.1524C34.7748 21.9095 34.7748 21.5157 34.5307 21.2727Z"
          fill={color || '#1F1F1F'}
        />
      </g>
      <defs>
        <clipPath id="clip0_2690_42543">
          <rect
            width="32"
            height="31.8459"
            fill="white"
            transform="translate(16 16.7721)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ThumbUpSvg;
